import gql from "graphql-tag";
import {
  LOCAL_TOGGLE_MESSAGES,
  LOCAL_TOGGLE_PREMIUM_COFOUNDER,
} from "../../apollo-state/graphql/mutations";

import currentDateIsNewer from "../../utils/compare-dates";
import dateDiffInDays from "../../utils/diff-days-between-dates";

const SEND_MESSAGE_QUERY = gql`
  query sendMessage($otherUserId: ID) {
    sendMessage(otherUserId: $otherUserId) {
      conversation {
        id
        users {
          id
          profilePic
          firstName
        }
      }
      numberOfFreeConvos
      nextAvailableFreeConvo
    }
  }
`;

const sendMessage = (
  client,
  otherUserIdFromLocal,
  me,
  profilePicFromLocal,
  firstNameFromLocal,
  convoId
) =>
  new Promise((resolve, reject) => {
    if (convoId) {
      client.mutate({
        mutation: LOCAL_TOGGLE_MESSAGES,
        variables: {
          convoOtherUserId: otherUserIdFromLocal,
          convoOtherUserProfilePic: profilePicFromLocal,
          convoOtherUserFirstName: firstNameFromLocal,
          activeConvoId: convoId,
        },
      });
      resolve({ canSendMessage: true });
    }
    client
      .query({
        query: SEND_MESSAGE_QUERY,
        variables: { otherUserId: otherUserIdFromLocal },
        fetchPolicy: "network-only",
      })
      .then((resp) => {
        const { users } = resp.data.sendMessage.conversation;
        const conversationId = resp.data.sendMessage.conversation.id;
        let alreadyExists = true;
        let id, firstName, profilePic;

        if (!users) {
          alreadyExists = false;
        } else {
          const otherUser = users.filter((user) => user.id !== me.id)[0];
          id = otherUser.id;
          firstName = otherUser.firstName;
          profilePic = otherUser.profilePic;
        }

        if (
          !alreadyExists &&
          me &&
          me.numberOfFreeConvos === 0 &&
          !me.hasValidCoFounderSubscription &&
          (me.nextAvailableFreeConvo
            ? !currentDateIsNewer(me.nextAvailableFreeConvo)
            : false)
        ) {
          client.mutate({
            mutation: LOCAL_TOGGLE_PREMIUM_COFOUNDER,
            variables: {
              message:
                dateDiffInDays(
                  new Date(),
                  new Date(resp.data.sendMessage.nextAvailableFreeConvo)
                ) == 2
                  ? "Looks like your next free messages are used up for today - check back tomorrow for another."
                  : `Looks like your next free conversation is in ${dateDiffInDays(
                      new Date(),
                      new Date(resp.data.sendMessage.nextAvailableFreeConvo)
                    )} days`,
            },
          });
        } else {
          client.mutate({
            mutation: LOCAL_TOGGLE_MESSAGES,
            variables: {
              convoOtherUserId: alreadyExists ? id : otherUserIdFromLocal,
              convoOtherUserProfilePic: alreadyExists
                ? profilePic
                : profilePicFromLocal,
              convoOtherUserFirstName: alreadyExists
                ? firstName
                : firstNameFromLocal,
              activeConvoId: alreadyExists ? conversationId : null,
            },
          });
        }
        resolve({
          canSendMessage:
            alreadyExists ||
            me.numberOfFreeConvos > 0 ||
            me.hasValidCoFounderSubscription,
        });
      })
      .catch((err) => {
        console.log(err);
        reject();
      });
  });

export default sendMessage;
